import { render } from "./EditQuantityArticleCerere.vue?vue&type=template&id=514b76c8&scoped=true&ts=true"
import script from "./EditQuantityArticleCerere.ts?vue&type=script&lang=ts"
export * from "./EditQuantityArticleCerere.ts?vue&type=script&lang=ts"

import "./EditQuantityArticleCerere.vue?vue&type=style&index=0&id=514b76c8&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514b76c8"]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QInput,QCheckbox,QBtn});qInstall(script, 'directives', {ClosePopup});
